import css from './Note.module.scss'
import colors from '../../styles/jscolors.module.scss'
import { motion } from 'framer-motion'

export default function Note({
	text,
	icon,
	color,
	customColors,
	motionProps,
	// key,
}) {
	// ref for framer-motion
	return (
		<motion.div
			{...motionProps}
			// key={key}
			className={`${css['note']} ${color ? `sem--secondary-${color}` : undefined}`}
			style={
				customColors && {
					backgroundColor: colors[customColors.bg],
				}
			}>
			{icon && <i className={icon} />}
			<p>{text}</p>
		</motion.div>
	)
}
